export default __webpack_public_path__ + "static/media/classes.f9fd6c49.svg";